import React from "react";

import {
  GridRowEditStartParams,
  GridRowEditStopParams,
  GridRowId,
  GridRowModes,
  GridRowModesModel,
  MuiEvent,
} from "@mui/x-data-grid";
// import { useBlocker } from "react-router-dom";
import { GridRowModesModelProps } from "@mui/x-data-grid/models/api/gridEditingApi";
// import { unstable_usePrompt, useBlocker, useNavigate } from "react-router-dom";

export type UseRowModesModelReturn = [
  GridRowModesModel,
  {
    isBulkEditing: boolean;
    isDirty: boolean;
    isRowEditing: (id: GridRowId) => boolean;
    onRowModesModelChange: React.Dispatch<
      React.SetStateAction<GridRowModesModel>
    >;
    onRowEditStart: (params: GridRowEditStartParams, event: MuiEvent) => void;
    onRowEditStop: (params: GridRowEditStopParams, event: MuiEvent) => void;
    startEditingRow: (id: GridRowId) => () => void;
    stopEditingRow: (id: GridRowId, ignoreModifications: boolean) => () => void;
  }
];

export default function useRowModesModel(): UseRowModesModelReturn {
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>(
    {}
  );
  const isEditing = (props?: GridRowModesModelProps) =>
    props?.mode === GridRowModes.Edit;

  const isDirty = React.useMemo(
    () => Object.values(rowModesModel).some(isEditing),
    [rowModesModel]
  );
  const isBulkEditing = React.useMemo(
    () => Object.values(rowModesModel).filter(isEditing).length > 1,
    [rowModesModel]
  );
  const isRowEditing = React.useCallback(
    (id: GridRowId) => isEditing(rowModesModel[id]),
    [rowModesModel]
  );

  const alertEditing = React.useCallback(
    (event: BeforeUnloadEvent) => {
      console.log("alertEditing", {
        event: event.type,
        isBulkEditing,
        isDirty,
      });
      if (isBulkEditing || isDirty) {
        event.preventDefault();
        event.returnValue = "";
      }
    },
    [isBulkEditing, isDirty]
  );

  /**
   * Effects
   */
  React.useEffect(() => {
    window.addEventListener("beforeunload", alertEditing);

    // NOTE: uncomment if we need to persist rows into local storage
    // window.addEventListener("unload", () => {});
    return () => {
      window.removeEventListener("beforeunload", alertEditing);
    };
  }, [rowModesModel]);

  // unstable_usePrompt({
  //   when: isDirty,
  //   message: "Você possui alterações não salvas. Tem certeza que deseja sair?",
  // });
  // const navigate = useNavigate();
  // const blocker = useBlocker(true);
  // console.log("useBlocker state", blocker.state);
  // // const navigation = useNavigate();
  // React.useEffect(() => {
  //   console.log("blocker state changed", blocker.state);
  //   if (blocker.state === "blocked") {
  //     const confirm = window.confirm(
  //       "Você possui alterações não salvas. Tem certeza que deseja sair?"
  //     );
  //     if (confirm) {
  //       blocker.proceed();
  //     } else {
  //       blocker.reset();
  //     }
  //   }
  // }, [blocker]);

  React.useEffect(() => {
    console.log({ isDirty });
  }, [isDirty]);

  const startEditingRow = (id: GridRowId) => () => {
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.Edit },
    }));
  };

  const stopEditingRow =
    (id: GridRowId, ignoreModifications: boolean = true) =>
    () => {
      setRowModesModel((prev) => ({
        ...prev,
        [id]: { mode: GridRowModes.View, ignoreModifications },
      }));
    };

  const onEditChange = (
    _params: GridRowEditStartParams | GridRowEditStopParams,
    event: MuiEvent
  ) => {
    event.defaultMuiPrevented = true;
  };

  return [
    rowModesModel,
    {
      isBulkEditing,
      isDirty,
      isRowEditing,
      onRowModesModelChange: setRowModesModel,
      onRowEditStart: onEditChange,
      onRowEditStop: onEditChange,
      startEditingRow,
      stopEditingRow,
    },
  ];
}
